<template>
  <div class="container">
    <!-- 操作区域 -->
    <el-card class="operation-card">
      <div class="flex-container">
        <el-input v-model="token" placeholder="令牌值" style="width: 200px"></el-input>
        <el-input
          type="textarea"
          v-model="accountIds"
          :rows="1"
          placeholder="账户名（每行一个）"
          style="width: 300px; margin: 0 20px"
        ></el-input>
        <el-button type="primary" @click="handleQuery" :loading="queryLoading">查询</el-button>

        <el-divider direction="vertical"></el-divider>

        <el-label>
          操作金额
        </el-label>
        <el-input
          v-model="amount"
          :min="0"
          :precision="2"
          placeholder="操作金额"
          style="width: 150px"
        ></el-input>
        <el-button type="danger" @click="openDialog">转出所有余额</el-button>
<!--        <el-checkbox v-model="transferAll" style="margin-left: 10px">转出所有余额</el-checkbox>-->
        <!-- 弹窗组件 -->
        <el-dialog
          title="输入调用失败后金额缩减区间"
          :visible.sync="dialogVisible"
          width="30%"
          @close="resetForm"
        >
          <el-form :model="form" :rules="rules" ref="numberForm">
            <el-form-item label="输入账户转出金额调用失败后金额缩减区间" prop="number">
              <el-input
                v-model.number="form.number"
                type="number"
                placeholder="请输入大于0的金额区间"
              ></el-input>
            </el-form-item>
          </el-form>

          <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleConfirm">确 定</el-button>
<!--            TransformAll-->
      </span>
        </el-dialog>
        <div style="margin-left: 20px">
          <el-button type="success" @click="handleTransfer('IN')">转入</el-button>
          <el-button type="danger" @click="handleTransfer('OUT')">转出</el-button>
        </div>
      </div>
    </el-card>

    <!-- 数据表格 -->
    <el-card class="data-card">
      <el-table
        :data="tableData"
        border
        @selection-change="handleSelectionChange"
        style="width: 100%"
        @sort-change="handleSortChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="companyName" label="广告主公司"></el-table-column>
        <el-table-column prop="name" label="广告主用户"></el-table-column>
        <el-table-column
          prop="cashBalance"
          label="现金余额"
          sortable
          :sort-method="(a, b) => a.cashBalance - b.cashBalance"
        ></el-table-column>
        <el-table-column
          prop="todayConsume"
          label="今日消耗"
          sortable
          :sort-method="(a, b) => a.todayConsume - b.todayConsume"
        ></el-table-column>
        <el-table-column
          prop="yestConsume"
          label="昨日消耗"
          sortable
          :sort-method="(a, b) => a.yestConsume - b.yestConsume"
        ></el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>

import axios from "axios";
export default {
  data() {
    // 自定义验证规则
    const validateNumber = (rule, value, callback) => {
      if (value === "" || value === null) {
        callback(new Error("请输入数字"));
      } else if (value <= 0) {
        callback(new Error("数字必须大于0"));
      } else {
        callback();
      }
    };
    return {
      token: '',
      accountIds: '',
      amount: 0,
      tableData: [],
      sortProp: '',
      sortOrder: '',
      selectedData: [], // 选中的数据
      queryLoading: false, // 查询加载状态
      dialogVisible: false,
      form: {
        number: null
      },
      rules: {
        number: [
          { required: true, validator: validateNumber, trigger: "blur" }
        ]
      }
    }
  },
  methods: {
    openDialog() {
      this.dialogVisible = true;
    },
    handleConfirm() {
      this.$refs.numberForm.validate(valid => {
        if (valid) {
          console.log("输入的数字是：", this.form.number);

          this.TransformAll()

        }
      });
    },
    resetForm() {
      this.$refs.numberForm.resetFields();
    },
    //转出所有
    async TransformAll() {
      const accounts = this.selectedData;

      const requests = accounts.map(user => {
        return (async () => {
          let currentAmount = user.cashBalance;
          const MAX_RETRIES = 20;
          let attempts = 0;

          while (attempts++ < MAX_RETRIES) {
            try {
              // 发送请求并获取响应
              const res = await this.sendTransferRequest({
                accountId: user.uuid,
                amount: currentAmount,
                type: "OUT",
                token: this.token
              });

              // 检查响应中的业务错误
              if (res.data.message === "转出金额大于当前账户余额") {
                // 手动抛出错误触发 catch
                throw new Error("INSUFFICIENT_BALANCE");
              }

              // 成功时直接返回
              return res;
            } catch (error) {
              // 处理特定业务错误
              if (error.message === "INSUFFICIENT_BALANCE" ||
                (error.response.data.message === "转出金额大于当前账户余额")) {
                currentAmount -= this.form.number;

                // 金额耗尽处理
                if (currentAmount <= 0) {
                  throw new Error(`账户 ${user.uuid} 转出失败：可用金额不足`);
                }

                // 添加延迟防止高频请求（可选）
                await new Promise(resolve => setTimeout(resolve, 50));
                continue;
              }

              // 其他错误直接抛出
              throw error;
            }
          }
          throw new Error(`账户 ${user.uuid} 超过最大重试次数`);
        })();
      });

      try {
        await Promise.all(requests);
        this.dialogVisible = false;
        this.$message.success('操作成功');
        this.handleQuery();
      } catch (error) {
        this.$message.error(error.message || '部分操作失败');
      }
    },
    handleSelectionChange(selection) {
      this.selectedData = selection; // 将选中的数据保存到 selectedData
      console.log('选中的数据:', selection);
    },
    async handleQuery() {
      if (!this.validateQueryParams()) return;

      this.queryLoading = true;
      this.tableData = []; // 清空表格数据

      const accountIds = this.getAccountIds();
      try {
        // 循环发送请求
        for (const accountId of accountIds) {
          const data = await this.fetchAccountData(this.token, accountId);
          console.log(data);

          // 查找是否有名称匹配的项
          const matchedItem = data.data.data.list.find(obj => obj.name === accountId);

          // 根据匹配结果推入对应数据
          this.tableData.push(
            matchedItem
              ? matchedItem
              : data.data.data.list[0] // 未找到时使用默认项
          );
        }
      } catch (error) {
        this.$message.error('查询失败：' + error.message);
      } finally {
        this.queryLoading = false;
      }
    },

    async fetchAccountData(cookie,accountId) {
      // 模拟请求单个账户数据
     return   await axios.post('https://control.zjwec.cn/api/vivo/subAccountList', {
        token:cookie,
        accountId:accountId
      })

    },

    validateQueryParams() {
      if (!this.token) {
        this.$message.error('请输入令牌值');
        return false;
      }
      if (this.getAccountIds().length === 0) {
        this.$message.error('请输入至少一个账户ID');
        return false;
      }
      return true;
    },

    getAccountIds() {
      return this.accountIds.split('\n')
        .map(id => id.trim())
        .filter(id => id);
    },

    async handleTransfer(type) {
      // if (!this.validateParams()) return;


      const accounts = this.selectedData;
      const requests = accounts.map(user =>
        this.sendTransferRequest({
          accountId:user.uuid,
          amount:  this.amount,
          type:type,
          token:this.token
        })
      );

      try {
        await Promise.all(requests);
        this.$message.success('操作成功');
        this.handleQuery(); // 刷新数据
      } catch (error) {
        this.$message.error('部分操作失败');
      }
    },

    handleRowTransfer(row, type) {
      this.amount = type === 'OUT' ? row.cash : 0;
      this.accountIds = row.accountId;
      this.handleTransfer(type);
    },

    handleSortChange({ prop, order }) {
      this.sortProp = prop;
      this.sortOrder = order;
      // 这里可以调用后端排序接口或前端排序逻辑
    },

    async sendTransferRequest(params) {

      if (params.type === "IN"){
        return this.$axios.post('https://control.zjwec.cn/api/vivo/secondTransferIn', params);
      }else{
        return this.$axios.post('https://control.zjwec.cn/api/vivo/secondTransferOut', params);
      }

      // 实际接口调用

    }
  }
}
</script>
<style scoped>
/* 容器样式 */
.container {
  padding: 20px;
}

/* 操作区域卡片样式 */
.operation-card {
  margin-bottom: 20px;
}

/* 操作区域布局样式 */
.flex-container {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

/* 数据表格卡片样式 */
.data-card .el-table {
  margin-top: 20px;
}

/* 表格内链接样式 */
.data-card .el-table .el-link {
  margin: 0 5px;
}

/* 移动端适配 */
@media (max-width: 768px) {
  .flex-container {
    flex-direction: column;
    align-items: flex-start !important;
  }

  .flex-container > * {
    margin: 5px 0 !important;
    width: 100% !important;
  }

  .flex-container .el-divider--vertical {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/login/zhzqian.vue